import React from "react";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import "../../../../styles/components/cotizaciones.scss";
import { Button } from "devextreme-react";
import { checkAccess, ids, realCheckAccess } from "../../../../helpers/rolAccess";
import { loadTabs } from "../../../Header/actions";
import Step1 from "./Forms/Step1";
import FormCotizaciones from "./Forms/FormCotizaciones";
import { showHideFormCotizaciones } from "./Forms/actions";
import routes, { paths } from "../../../../config/routes";
import placeholder from "../../../../images/placeholder.png";

import banner_home_cotizacion from "../../../../images/banner_home_cotizacion.jpg";

class Cotizaciones extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      currentStep: 1,
      step1: {},
      step2: {},
      step3: {},
    };
  }

  componentDidUpdate = (prevProps) => {
    if (
      (prevProps.userAccessIds === null &&
        Array.isArray(this.props.userAccessIds)) ||
      this.props.currentHeader !== "Cotizaciones "
    ) {
      this.loadTabs();
    }
    if (prevProps.companyId !== this.props.companyId) {
      this.props.dispatch(push(paths.root))
    }
  };

  loadTabs = () => {
    const tabs = [];
    // if (checkAccess(ids.declaracionCotizacion, this.props.userAccessIds)) {
      tabs.push({ text: "Declaración", contentId: 1, isActive: true });
    // }

    this.props.dispatch(
      loadTabs(
        "Cotizaciones ",
        "",
        tabs,
        tabs.length ? tabs[0].contentId : null
      )
    );
  };

  handleNewCotizacion = () => {
    this.props.dispatch(showHideFormCotizaciones(true));
  }

  render() {
    return (
      <>
        <FormCotizaciones/>
          <div id={"cotizaciones"} style={{flexDirection: "column"}}>
            <br/>
            <div style={{backgroundColor: "rgb(235, 255, 254)", display: "flex", padding: "0px 0px"}}>
              <div>
                <img src={banner_home_cotizacion} alt="placeholder" style={{width: "100%", padding: "2rem"}}/>
              </div>
              <div style={{display: "flex", flexDirection: "column", padding: "2rem"}}>
                <h5 style={{ lineHeight: "1.6", fontSize: 16, textAlign: "justify" }}>
                  En este formulario podrás declarar las cotizaciones de tu empresa.
                  Sin embargo, debes recordar que el método oficial para realizar la declaración de tus cotizaciones es vía Previred, y este formulario es solo una alternativa como lo era la declaración en caja en Red de Agencias.
                </h5>
                <div className="cotizaciones-form-buttons" style={{display: "flex", justifyContent: "end", alignItems: "center", paddingTop: "25%", paddingBottom: "5%"}}>
                  <Button
                    text="Declarar en formulario"
                    type="success"
                    className="next-button"
                    // onClick={() => this.props.dispatch(push(paths.cotizacionesForm))}
                    onClick={() => this.handleNewCotizacion()}
                    style={{ height: "40px", marginRight: "5px" }}
                  />

                  <Button
                    text="Redirigirme a Previred"
                    className="next-button"
                    onClick={() => window.open("https://www.previred.com", '_blank')}
                    style={{ height: "40px" }}
                  />
                </div>
              </div>
            </div>
          </div>
      </>

    );
  }
}

const mapStateToProps = (state) => ({
  selectedTab: state.header.contentId,
  currentHeader: state.header.title,
  userAccessIds: state.global.userAccessIds,
  companyId: state.global.companyId,
  sucursalId: state.global.sucursalId,
  isEditTrabajadores: state.solicitudesAgendaSel.isEditTrabajadores,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => {
    dispatch(action);
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Cotizaciones);
